// 사용자 알림센터 API 래퍼.

import type { NotificationDto } from "@oo/shared";
import { api } from "@/api/client.ts";

export interface NotificationsView {
  notifications: NotificationDto[];
  unread: number;
}

// 알림 목록 + 미읽음 수 조회.
export async function getNotifications(): Promise<NotificationsView> {
  const data = await api.get<{ notifications: NotificationDto[]; unread: number }>(
    "/me/notifications",
  );
  return { notifications: data.notifications, unread: data.unread };
}

// 전체 알림 읽음 처리.
export async function markAllNotificationsRead(): Promise<void> {
  await api.post("/me/notifications/read");
}

// 알림 비우기(전체 삭제).
export async function clearAllNotifications(): Promise<void> {
  await api.delete("/me/notifications");
}
